// extracted by mini-css-extract-plugin
export default {"notFoundPage":"lrpocXZXrojld4oxn04V","goodRating":"O0ugAsq8d2cCiyDUhqsp","badRating":"jxJWlUS9nd9j6QeM1V2q","starStyling":"ZDbPztn5xCk8sOnKXNWo"};